export default __webpack_public_path__ + "static/media/sleeping-caverns-sm.2cfe350f.jpg";